import Vue from "vue";
import VueDND from 'awe-dnd';

// Include bootstrap vue
Vue.use(VueDND);

export default VueDND;
